var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#5a8127",
    height: 18,
    width: 14,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-13.2 -13.2 356.4 356.4",
    stroke: "#5a8127",
    strokeWidth: 1.32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M325.607 79.393c-5.857-5.857-15.355-5.858-21.213.001l-139.39 139.393L25.607 79.393c-5.857-5.857-15.355-5.858-21.213.001-5.858 5.858-5.858 15.355 0 21.213l150.004 150a14.999 14.999 0 0021.212-.001l149.996-150c5.859-5.857 5.859-15.355.001-21.213z"
  })));
}
export default SvgChevronDownColored;